import { render, staticRenderFns } from "./recentOffers.vue?vue&type=template&id=4a1b56ea"
import script from "./recentOffers.vue?vue&type=script&lang=js"
export * from "./recentOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports